/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface DeleteDashboardMeDashboardsDashboardIdDelete$Params {
  dashboard_id: string;
}

export function deleteDashboardMeDashboardsDashboardIdDelete(
  http: HttpClient,
  rootUrl: string,
  params: DeleteDashboardMeDashboardsDashboardIdDelete$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteDashboardMeDashboardsDashboardIdDelete.PATH, 'delete');
  if (params) {
    rb.path('dashboard_id', params.dashboard_id, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

deleteDashboardMeDashboardsDashboardIdDelete.PATH = '/me/dashboards/{dashboard_id}';
